export class DataCatalogTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<DataCatalogType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<DataCatalogType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
